import React from 'react';
import {createRefetchContainer, graphql} from 'react-relay';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import SharedReportLogin from './SharedReportLogin';
import GenericSavedReportConductor from '../saved-report/GenericSavedReportConductor';

const SharedReportPage = ({viewer, match, relay, shareType, setLocaleFromBrowser}) => {
	const sharedReport = viewer.sharedReport;
	const sharedId = match.params.sharedId;

	setLocaleFromBrowser();

	return sharedReport ? (
		<GenericSavedReportConductor savedReport={sharedReport.savedReport} sharedId={sharedId} shareType={shareType} />
	) : (
		<SharedReportLogin sharedId={sharedId} refetch={relay.refetch} />
	);
};

const SharedReportQuery = graphql`
	query SharedReportPage_Query($sharedId: String) {
		viewer {
			actualPersonId
			component(name: "shared_report")
			...SharedReportPage_viewer @arguments(sharedId: $sharedId)
		}
	}
`;

export {SharedReportQuery};

export default injectIntl(
	withRouter(
		createRefetchContainer(
			SharedReportPage,
			{
				viewer: graphql`
					fragment SharedReportPage_viewer on Viewer @argumentDefinitions(sharedId: {type: "String"}) {
						id
						sharedReport(sharedId: $sharedId) {
							id
							savedReport {
								...GenericSavedReportConductor_savedReport
								id
								type
								name
							}
						}
					}
				`,
			},
			graphql`
				query SharedReportPageRefetchQuery($sharedId: String) {
					viewer {
						...SharedReportPage_viewer @arguments(sharedId: $sharedId)
					}
				}
			`
		)
	)
);
